import { render, staticRenderFns } from "./home_view.vue?vue&type=template&id=08485f0e&scoped=true&"
import script from "./home_view.vue?vue&type=script&lang=js&"
export * from "./home_view.vue?vue&type=script&lang=js&"
import style0 from "./home_view.vue?vue&type=style&index=0&id=08485f0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08485f0e",
  null
  
)

export default component.exports